import React, {ReactElement} from "react"
import Consts from "./consts";
import {InfoTooltip} from "./components/components";
import {AdditionalField} from "../user/UserContext"

interface Club {
    verein_ID: number,
    fullName: string,
    fullNameDeclined: string,
    shortName: string,
    domain: string,
    title: string,
    logo?: ReactElement,
    color: string,
    fontColor?: string,
    fontColorInverse?: string,
    showLogo: boolean,
    iban: string,
    bic?: string,
    bankname?: string,
    bank?: {
        bic: string,
        bankname: string,
    }
    facebook?: string,
    memberStates: Record<number, string>,
    memberStatesShort?: Record<number, string>,
    arnName: string,
    arn: string,
    sendReminders: boolean,
    address: string,
    creditorID: string,
    email: string,
    phone?: number,
    website: string,
    links?: {
        dataprotection?: string,
        statuten?: string,
        agbs?: string,
    },
    stripeKey?: string,
    paymentMethods: string[],
    msFees: {
        junior: number,
        normal: number,
        senior: number,
        supporter?: number,
        addText?: string,
    },
    noMembership?: boolean,
    otherClubs?: number[],
    additionalFields?: Partial<AdditionalField>[],
    roomDependencies?: {
        localRoomID: number,
        foreignRoomID: number
    }[],
    showDiscounts?: boolean
    vatRegisteredSince?: number
}


type _domainMap = Record<string, Club>
const memberStatesStandard = {
    0: "Nichtmitglied",
    1: "ordentliches Mitglied",
    2: "außerordentliches Mitglied",
    3: "unterstützendes Mitglied",

    400: "befreites Mitglied",
    401: "ruhendes Mitglied",
    410: "gesperrte Person",
    //402: "Trainer",

    500: "Zeugwart Stellvertretung",
    600: "Zeugwart",

    700: "Sportliche Leitung Stellvertretung",
    800: "Sportliche Leitung",
    900: "Kassier Stellvertretung",
    1000: "Kassier",
    1100: "Schriftführer Stellvertretung",
    1200: "Schriftführer",
    1300: "Obfrau/Obmann Stellvertretung",
    1400: "Obfrau/Obmann",


    //100: "Vorstand"
};

const stripeMethods = ["sepa", "card", "sofort", "bank", "voucher"];

// https://www.iban-rechner.de/iban_validieren.html


const domainMapInitial: _domainMap = {

};
const domainMap: _domainMap = Object.keys(domainMapInitial).reduce((obj, curr) => ({
    ...obj,
    [curr]: {
        ...domainMapInitial[curr],
        iban: domainMapInitial[curr].iban,
        memberStatesShort: Object.keys(domainMapInitial[curr].memberStates)
            .reduce((obj, k) => ({
                ...obj,
                [parseInt(k)]: domainMapInitial[curr].memberStates[parseInt(k)].split(" ").map((u: any) => u.replace("(", "")[0]).join(".")
            }), {})
    }
}), {});
const domainName = window.location.hostname.split(".").slice(-2).join(".");
const domainNameLong = window.location.hostname.split(".").slice(-3).join(".");
const clubMap = Object.keys(domainMap).reduce((obj, curr) => ({...obj, [domainMap[curr].verein_ID]: curr}), {});


let ClubPart = domainMap[domainNameLong] || (
    (domainName.indexOf("localhost") > -1 || domainName.indexOf("10.0.0") > -1 || !domainMap[domainName]) ?
        domainMap["vereinfacht.at"] :
        domainMap[domainName]
);
// @ts-ignore
if (window?.VEREINfachtConfig?.verein_ID) {
// @ts-ignore
    ClubPart = Object.values(domainMap).find(a => a.verein_ID === window?.VEREINfachtConfig?.verein_ID) || domainMap["vereinfacht.at"];
}

if (Consts.f(true, false)) {

    //ClubPart = domainMap["tv-enns.vereinfacht.at"];
    //ClubPart = domainMap["schwanenstadt.vereinfacht.at"];
    //ClubPart = domainMap["meine.bewegungswelt.at"];
    //ClubPart = domainMap["mein-turnverein.at"];
    //ClubPart = domainMap["vereinfacht.at"];
    //ClubPart = domainMap["my.vereinfacht.com"];
    //ClubPart = domainMap["atv-andorf.vereinfacht.at"];
    ClubPart = domainMap["mein.oetb-linz.at"];
    //ClubPart = domainMap["itv.vereinfacht.at"];
    //ClubPart = domainMap["tv-taufkirchen.vereinfacht.at"];
    //ClubPart = domainMap["tv-steyr.vereinfacht.at"];
    //ClubPart = domainMap["atv-schwertberg.vereinfacht.at"];
    //ClubPart = domainMap["gunclub.vereinfacht.at"];
    //ClubPart = domainMap["atv-andorf-schwimmen.vereinfacht.at"];
    //ClubPart = domainMap["vbc-steyr.vereinfacht.at"];
    //ClubPart = domainMap["turnvereinmondsee.vereinfacht.at"];
    //ClubPart = domainMap["valentinmuseum.vereinfacht.at"];
    //ClubPart = domainMap["atv-weyer.vereinfacht.at"];
    //ClubPart = domainMap["atv-test.vereinfacht.at"];

}

const Club = {
    ...ClubPart,
}; // domain: window.location.host

const placeholderClub: Club = {
    verein_ID: -1,
    fullName: "",
    fullNameDeclined: "",
    shortName: "",
    domain: "vereinfacht.at",
    title: "VEREINfacht",
    color: "#aaa",
    fontColor: "black",
    fontColorInverse: "black",
    email: "max@vereinfacht.at",
    showLogo: true,
    // @ts-ignore
    logo: "",
    iban: "",
    bic: "",
    bankname: "",
    stripeKey: "",
    paymentMethods: stripeMethods,
    website: "vereinfacht.at",
    memberStates: {
        ...memberStatesStandard,
    },
    arnName: "",
    arn: "",
    sendReminders: true,
    address: "",
    creditorID: "",
    phone: 0,
    links: {},
    msFees: {
        junior: 40,
        normal: 50,
        senior: 50,
        supporter: 20,
    },
}


export {domainMap, clubMap, placeholderClub, Club};
